import React, { Fragment, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { IFoodOrderingProduct, INewIVariant } from "pages/guest/Customer/ClientPortal/FoodOrdering/Menu";
import "./addRemoveButton.scss";
import { ICartLineItem } from "redux/reducers/customer/models/cart";
import classNames from "classnames";
import axios from "axios";
import useOnclickOutside from "hooks/useOnclickOutside/useOnclickOutside";

interface IAddRemoveButtonProps {
  onRemoveLineItem: (line_item: ICartLineItem) => void;
  onHandleQuantityChange: (line_item: ICartLineItem) => void;
  onAddToBag: (product: any, variant_id: number, variant?: INewIVariant) => void;
  quantity: number;
  line_item: ICartLineItem;
  product: IFoodOrderingProduct;
  variant_id: number;
  variant?: INewIVariant;
  disableRemoveLineItem?: boolean;
}

interface IAddRemoveButtonState {
  adjustingQuantity: boolean;
}

const AddRemoveButton: React.FC<IAddRemoveButtonProps> = props => {
  const {
    quantity,
    line_item,
    product,
    variant,
    variant_id,
    disableRemoveLineItem,
    onAddToBag,
    onRemoveLineItem,
    onHandleQuantityChange,
  } = props;

  let timeout: NodeJS.Timeout;

  const [addRemoveButtonState, setAddRemoveButtonState] = useState<IAddRemoveButtonState>({
    adjustingQuantity: false,
  });

  const adjustQuantityRef = useRef();

  function removeLineItem(line_item: ICartLineItem) {
    onRemoveLineItem(line_item);
    setAddRemoveButtonState(prevState => ({ ...prevState, adjustingQuantity: false }));
  }

  function handleQuantityChange(line_item: ICartLineItem) {
    console.log(line_item);
    // clearTimeout(timeout);

    onHandleQuantityChange(line_item);

    // timeout = setTimeout(() => {
    //   setAddRemoveButtonState(prevState => ({ ...prevState, adjustingQuantity: false }));
    // }, 5000);
  }

  function addToBag(product: any, variant_id: number, variant?: INewIVariant) {
    // clearTimeout(timeout);

    onAddToBag(product, variant_id, variant);

    // timeout = setTimeout(() => {
    //   setAddRemoveButtonState(prevState => ({ ...prevState, adjustingQuantity: false }));
    // }, 2000);
  }

  function handleAdjustingQuantity() {
    // clearTimeout(timeout);

    setAddRemoveButtonState(prevState => ({
      ...prevState,
      adjustingQuantity: true,
    }));

    // timeout = setTimeout(() => {
    //   setAddRemoveButtonState(prevState => ({ ...prevState, adjustingQuantity: false }));
    // }, 5000);
  }

  const clickOutsideRef = useOnclickOutside(() => {
    setAddRemoveButtonState(prevState => ({ ...prevState, adjustingQuantity: false }));
  });

  return (
    <div ref={clickOutsideRef}>
      {!addRemoveButtonState.adjustingQuantity && !disableRemoveLineItem && (
        <div
          onClick={() =>
            quantity > 0 ? handleAdjustingQuantity() : onAddToBag(product, variant_id, variant && variant)
          }
          ref={adjustQuantityRef}
          className="food-ordering-item-button-container"
        >
          {quantity > 0 ? (
            <div>{quantity}</div>
          ) : (
            <div>
              <FontAwesomeIcon size="1x" fixedWidth className={"food-ordering-item-button-icon"} icon={faPlus} />
            </div>
          )}
        </div>
      )}

      {(addRemoveButtonState.adjustingQuantity || disableRemoveLineItem) && quantity > 0 && (
        <div
          className={classNames("food-ordering-item-add-to-cart-button-container", {
            "slide-open-right": (addRemoveButtonState.adjustingQuantity || disableRemoveLineItem) && quantity > 0,
          })}
          ref={adjustQuantityRef}
        >
          <div className="food-ordering-item-add-to-cart-button">
            <FontAwesomeIcon
              fixedWidth
              className={classNames("food-ordering-item-add-to-cart-button-icon", {
                "food-ordering-item-add-to-cart-button-icon_disabled": quantity <= 1 && disableRemoveLineItem,
              })}
              icon={quantity > 1 ? faMinus : faTrashCan}
              onClick={
                quantity > 1
                  ? () => handleQuantityChange(line_item)
                  : !disableRemoveLineItem
                  ? () => removeLineItem(line_item)
                  : null
              }
            />

            {quantity > 0 ? <p>{quantity}</p> : <p>1</p>}

            <FontAwesomeIcon
              fixedWidth
              className="food-ordering-item-add-to-cart-button-icon"
              icon={faPlus}
              onClick={() => addToBag(product, variant_id, variant && variant)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRemoveButton;
